import { Button } from '@mui/material';
import React from 'react';
import AddIcon from "@mui/icons-material/Add";


const AddButton = ({ onOpen }) => {
    return <Button
        sx={{
            borderRadius: "50px",
            height: "60px",
            width: "60px",
            position: "fixed",
            bottom: "80px",
            right: "40px",
            zIndex: 200,
            boxShadow: '2px 2px 40px 2px #3366FF33',
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#3F51B5' : theme.palette.primary.main,
            ":hover": { backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#4F5BCD' : 'primary.dark' }
        }}
        variant="contained"
        onClick={() => { onOpen() }}>
        <AddIcon sx={{ fontSize: "30px" }} />
    </Button>;
}



export default AddButton;